export const RECENT_HISTORY_LIST = 'recent_history_list';
export const RECENT_HISTORY_COUNT = 'recent_history_count';
// the num of days we want to keep track of PDP views in local storage which is 6 months
// More info here https://1stdibs.atlassian.net/browse/FINDING-14656
export const MAX_STORAGE_DAYS = 180; // 6 months
export const MAX_RECENTLY_VIEWED_ITEMS_STORAGE = 60;
export const MAX_CAROUSEL_RECENTLY_VIEWED_ITEMS = 10;
export const CAROUSEL_RECENTLY_VIEWED_ITEMS_PER_PAGE = 5;
export const CAROUSEL_RECENTLY_VIEWED_ITEMS_PER_PAGE_MOBILE = 1.9;
export const MAX_CAROUSEL_RECENTLY_VIEWED_ITEMS_TABLET = 8;
export const CAROUSEL_RECENTLY_VIEWED_ITEMS_PER_PAGE_TABLET = 4;
